var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action } from "mobx";
export class MasterEventInitialData {
    constructor(masterEventData) {
        this.eventName = masterEventData.eventName;
        this.id = masterEventData.id;
        this.team1Name = masterEventData.team1Name;
        this.team2Name = masterEventData.team2Name;
        this.leagueID = masterEventData.leagueID;
        this.leagueName = masterEventData.leagueName;
        this.eventDate = masterEventData.eventDate;
        this.eventTime = masterEventData.eventTime;
        this.sportID = masterEventData.sportID;
        this.sportName = masterEventData.sportName;
        this.isTeamSwapEnabled = masterEventData.isTeamSwapEnabled;
        this.eventDateTime = masterEventData.eventDateTime;
        this.regionId = masterEventData.regionId;
        this.betslipLine = masterEventData.betslipLine;
    }
    updateDateTime(formattedDate, formattedTime) {
        this.eventDate = formattedDate;
        this.eventTime = formattedTime;
    }
}
__decorate([
    observable,
    __metadata("design:type", String)
], MasterEventInitialData.prototype, "eventDate", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], MasterEventInitialData.prototype, "eventTime", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], MasterEventInitialData.prototype, "updateDateTime", null);
//# sourceMappingURL=MasterEventInitialData.js.map